import React, {createContext, useContext, useEffect, useState} from 'react';
import {FormikProvider, useFormik} from 'formik';
import {checkEmailIsValid} from '../../../../common/utils/form/checkEmailIsValid';
import {addCustomer} from '../../../../common/actions/customers';

const AddCustomerContext = createContext({});

export const useAddCustomerContext = () => useContext(AddCustomerContext);

export const AddCustomerContextProvider = ({shumaID, onSuccess, onFail, children}) => {
  const [loading, setLoading] = useState(false);
  const formik = useFormik({
    initialValues: {
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      idNumber: '',
      address: '',
      gender: {value: null},
      customerType: {value: null},
      status: {value: null},
    },
    validate: values => {
      let errors = {};

      if (!values.customerType.value) {
        errors.customerType = 'Required';
      }

      if (!values.status.value) {
        errors.status = 'Required';
      }

      switch (values.customerType.value) {
        case 1:
        case 2:
        case 3:
          ['firstName', 'idNumber'].forEach(function (item) {
            if (!values[item]) errors[item] = 'Required';
          });
          break;
        case 4:
          ['firstName', 'lastName'].forEach(function (item) {
            if (!values[item]) errors[item] = 'Required';
          });
          break;
        case 5:
        default:
          ['firstName', 'lastName', 'idNumber'].forEach(function (item) {
            if (!values[item]) errors[item] = 'Required';
          });
          break;
      }

      if (values.email && !checkEmailIsValid(values.email)) {
        errors['email'] = 'Invalid email address';
      }

      return errors;
    },
    onSubmit: async (values, formikHelpers) => {
      setLoading(true);
      try {
        const customer = await addCustomer(
          shumaID,
          values.firstName,
          values.lastName,
          values.phone,
          values.email,
          values.customerType.value,
          values.idNumber,
          values.gender.value,
          values.address,
          values.status.value,
        );

        onSuccess(customer);
        formikHelpers.resetForm();
      } catch (e) {
        onFail();
      } finally {
        setLoading(false);
      }
    }
  });

  useEffect(() => {
    formik.setValues({
      ...formik.values,
      firstName: '',
      lastName: '',
      idNumber: '',
    });
  }, [formik.values.customerType.value]);

  return (
    <AddCustomerContext.Provider value={{
      loading,
      isValid: formik.isValid,
      submitForm: formik.submitForm,
    }}>
      <FormikProvider value={formik}>
        {children}
      </FormikProvider>
    </AddCustomerContext.Provider>
  );
};